import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Form } from '@unform/web';

import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { Spinner } from '~/components';

import { t } from '~/helpers';

import { Container } from './styles';

import { closeDialog } from '~/store/modules/dialog/actions';

export default function CreateOrUpdate({ reference, data, create }) {
  const dispatch = useDispatch();

  const [fecharForm, setFecharForm] = React.useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const { loading, find, params } = useSelector(
    (state) => state.operacaoliberacaoremota
  );
  const initials = create ? data : { ...find, ...data };

  async function handleSubmit(param) {

    try {

      if (fecharForm) {
        await dispatch(closeDialog());
        return;
      }

      const schema = Yup.object().shape({
        poco_codigo: Yup.string().required(t('s.geral.validacao.campoobrigatorio')),
        bico_numero: Yup.string().required(t('s.geral.validacao.campoobrigatorio')),
        cond_cpf: Yup.string().required(t('s.geral.validacao.campoobrigatorio')),
        veic_placa_apresentacao: Yup.string().required(t('s.geral.validacao.campoobrigatorio')),
        km_liberacao: Yup.number().required( t('s.geral.validacao.campoobrigatorio')),
      });

      await schema.validate(param, {
        abortEarly: false,
      });


      if (create) {
        //await getLiberaAbastecimento(params);
      } else {
        //await dispatch(updateOperacaoAbastecimento(objSend, params));
      }
    } catch (err) {
      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });

        reference.current.setErrors(validationErrors);
      }
    }
  }


  useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (!loading) {
        //if (veiculo !== undefined && veiculo !== null) {
        //initials.idveiculo = veiculo;
        //}
        //reference.current.setData(initials);                
      }
    }
    return function cleanup() {
      mounted = false;
    };
  }, [loading, initials]);
  

  return (
    <Container>

      {isLoading ?
        <div style={{ zIndex: 999999 }}>
          <Spinner loading />
        </div> : ''
      }

      {loading ? (
        <div style={{ height: '14rem', width: '50rem' }}>
          <Spinner loading />
        </div>
      ) : (<>
        <Form ref={reference} initialData={initials} onSubmit={handleSubmit}>
          


        </Form>
      </>
        )}

  
    </Container>
  );
}

CreateOrUpdate.propTypes = {
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  create: PropTypes.bool.isRequired,
  data: PropTypes.objectOf(PropTypes.any),
};

CreateOrUpdate.defaultProps = {
  data: {},
};
